import { render, staticRenderFns } from "./CreateCustomerModal.vue?vue&type=template&id=f9b56bd8&"
import script from "./CreateCustomerModal.vue?vue&type=script&lang=ts&"
export * from "./CreateCustomerModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports